import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function GetResponsibleMedicalRecordUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { id: string }) => {
    return await repository.getResponsibleMedicalRecord(params)
  }
}
